import { Renderer } from "@with-nx/cms-ui";
import { Rule } from "@with-nx/simple-ui/atoms";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import { CatalogLayout } from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";

import LegalMenuDesktop from "../../components/w/LegalMenuDesktop";

export default function Page() {
  return (
    <CatalogLayout
      footerNoAngle
      title="Broadway Media - Cookie Policy"
      description="This Cookie Policy document was last updated on May 11, 2023"
    >
      <ReusableSection>
        <div className="container mx-auto max-w-7xl">
          <Row gutter={[36, 18]} justify="space-between">
            <Col xs={24} sm={24} md={24} lg={6} xl={6}>
              <LegalMenuDesktop />
            </Col>
            <Col xs={24} sm={24} md={24} lg={18} xl={18}>
              <Rule rule="hs" color="var(--font1)" display="block" bottom={24}>
                Cookie Policy
              </Rule>
              <Rule rule="ls" color="var(--font3)" display="block" bottom={24}>
                This Cookie Policy document was last updated on September 20,
                2024
              </Rule>
              <Renderer
                data={{
                  blocks: [
                    {
                      type: "paragraph",
                      data: {
                        text: `This Cookie Policy explains how Broadway Media Distribution, Inc. ("BMD") and its connected websites and applications ("our websites" or "the websites") use cookies and similar technologies. By accessing or using our websites, you consent to the use of cookies as described in this policy.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `1. What are Cookies?`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently, enhance user experiences, and provide information to website owners. Cookies can be temporary (session cookies) or permanent (persistent cookies).`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `2. Types of Cookies We Use`,
                      },
                    },
                    {
                      type: "list",
                      data: {
                        text: [
                          `Essential Cookies: These cookies are necessary for the basic functioning of our websites and enable you to navigate and use their features. They are usually set in response to actions made by you, such as logging in or filling out forms. These cookies do not store personally identifiable information.`,
                          `Analytics Cookies: We use analytics cookies to collect information about how visitors use our websites. This helps us understand and improve the performance of our websites, identify areas that need enhancement, and measure the effectiveness of our marketing campaigns. The information collected is aggregated and anonymous.`,
                          `Functional Cookies: These cookies enable our websites to remember choices you make, such as your preferred language or region. They enhance the personalized experience and provide enhanced features and customization options.`,
                          `Marketing Cookies: Marketing cookies are used to deliver relevant advertisements to you based on your interests. They track your browsing behavior across websites and may be used to build a profile of your interests.`,
                          `Third-Party Cookies: We may allow third-party service providers to place cookies on your device through our websites to assist us in analyzing usage patterns, delivering targeted advertisements, and providing other services. These third parties may collect information about your online activities over time and across different websites.`,
                        ],
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `3. Cookie Consent and Management`,
                      },
                    },
                    {
                      type: "list",
                      data: {
                        text: [
                          `Cookie Consent: When you visit our websites, we will request your consent to place non-essential cookies on your device. You can provide your consent by clicking "Accept" on the cookie banner or pop-up.`,
                          `Cookie Preferences: You have the right to manage your cookie preferences. You can modify your preferences or withdraw your consent at any time by adjusting your browser settings or using the cookie management tools provided on our websites. Please note that disabling certain cookies may affect the functionality and performance of our websites.`,
                          `Data Sharing: We may share cookie data with trusted third-party service providers for analytics, advertising, and other purposes. These providers are contractually obligated to protect the confidentiality and security of the data and are not permitted to use it for any other purposes.`,
                        ],
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `4. Your Rights`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `Under the General Data Protection Regulation (GDPR) and applicable data protection laws, you have the right to access, rectify, and delete your personal data collected through cookies. You can exercise these rights by contacting us using the contact information provided below.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `5. Updates to this Policy`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `We may update this Cookie Policy from time to time to reflect changes in our cookie practices or applicable laws. The updated policy will be effective upon posting on our websites, with the revised date indicated at the top. We encourage you to review this policy periodically.`,
                      },
                    },
                    {
                      type: "bold",
                      data: {
                        text: `6. Contact Us`,
                      },
                    },
                    {
                      type: "paragraph",
                      data: {
                        text: `If you have any questions or concerns about our use of cookies or this Cookie Policy, please contact us at: Broadway Media Distribution, Inc., 105 W 86th Street, #218, New York, NY 10024, United States of America; or via admin@broadwaymedia.com.`,
                      },
                    },
                  ],
                }}
              />
            </Col>
          </Row>
        </div>
      </ReusableSection>
    </CatalogLayout>
  );
}
